import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light.css';
var C = /** @class */ (function () {
    function C(elt) {
        if (typeof elt == 'string') {
            elt = document.getElementById(elt.substr(1));
        }
        if (!elt) {
            alert('Unknown element');
            elt = document.body;
        }
        this.e = elt;
    }
    C.select = function (elt) {
        return new C(elt);
    };
    C.prototype.c = function (obj, cla, sty, con) {
        if (cla === void 0) { cla = null; }
        if (sty === void 0) { sty = null; }
        if (con === void 0) { con = null; }
        var o = document.createElement(obj);
        this.e.appendChild(o);
        if (typeof cla != 'string') {
            con = sty;
            sty = cla;
            cla = null;
        }
        if (cla)
            o.setAttribute('class', cla);
        if (sty) {
            for (var k in sty) {
                ;
                o.style[k] = sty[k];
            }
        }
        if (con) {
            o.innerHTML = con;
        }
        return new C(o);
    };
    C.prototype.html = function (c) {
        this.e.innerHTML = c;
        return this;
    };
    C.prototype.class = function (names) {
        this.e.className = names;
        return this;
    };
    C.prototype.attr = function (key, val) {
        this.e.setAttribute(key, val);
        return this;
    };
    C.prototype.style = function (key, val) {
        this.e.style[key] = val;
        return this;
    };
    C.prototype.node = function () {
        return this.e;
    };
    C.prototype.on = function (evt, cb) {
        this.e.addEventListener(evt, cb);
        return this;
    };
    C.prototype.remove = function () {
        var p = this.e.parentElement;
        if (p)
            p.removeChild(this.e);
    };
    C.prototype.show = function () {
        this.e.style.display = '';
        return this;
    };
    C.prototype.hide = function () {
        this.e.style.display = 'none';
        return this;
    };
    C.prototype.tooltip = function (content) {
        tippy(this.e, { content: content, theme: 'light' });
        return this;
    };
    return C;
}());
export default C;
